import { defineComponent as _defineComponent } from 'vue'
import BTicketWrap from '../b-ticket-wrap/b-ticket-wrap.vue';

interface TicketPreloaderProps {
  hideBottomSection?: boolean;
  isCollapsed?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ticket-preloader',
  props: {
    hideBottomSection: { type: Boolean, default: false },
    isCollapsed: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,BTicketWrap }
}

})